import { useContext } from "react";
import { useStore } from "zustand";

import { RoutesUiStoreContext, RoutesUiStoreState } from "./RoutesProvider";

export function useRoutesUiStore(): RoutesUiStoreState;
export function useRoutesUiStore<T>(selector: (state: RoutesUiStoreState) => T): T;
export function useRoutesUiStore<T>(selector?: (state: RoutesUiStoreState) => T) {
  const store = useContext(RoutesUiStoreContext);
  if (!store) {
    throw new Error("useRoutesUiStore must be used within a RoutesUiStoreContextProvider");
  }
  // @ts-expect-error - this is a bug in the zustand types
  return useStore(store, selector);
}
